import { render } from "./Textarea.vue?vue&type=template&id=8ba757a4"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/fieldTypes/Textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8ba757a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8ba757a4', __exports__)) {
    api.reload('8ba757a4', __exports__)
  }
  
  module.hot.accept("./Textarea.vue?vue&type=template&id=8ba757a4", () => {
    api.rerender('8ba757a4', render)
  })

}


export default __exports__